import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.ash,
  tileBgColor: colors.cream,
  iconBgColor: colors.ash
};
export default imageGallery;